module.exports = __webpack_public_path__ + "media/images/emblems/Hofstetten-Flueh-blason-0dd8f5bcb5ca1bae456cd8c311ff6e1f.png";